// default value used in the sideEffects module
export const POLL_FOR_LIVE_TIMEOUT = 2000;

export const POLL_FOR_ATTENDANCES = 30000;
